import { Icon } from "semantic-ui-react";

import xentryImg from "assets/img/xentry.png";
import "components/Notes/NoteTypeIconLabel/NoteTypeIconLabel.scss";
import { APPOINTMENT_NOTE_TYPES } from "models";

type NoteTypeIconLabelProps = {
  type?: APPOINTMENT_NOTE_TYPES;
  isCarNote?: boolean;
};

type NoteTypeConfig = {
  iconColor: string;
  backgroundColor: string;
  icon?: string;
  isBackOrder?: boolean;
  isXentry?: boolean;
};

const NoteTypeIconMapConfig = new Map<APPOINTMENT_NOTE_TYPES | undefined, NoteTypeConfig>([
  [APPOINTMENT_NOTE_TYPES.Info, { backgroundColor: "#2185D0", icon: "info", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.BackOrder, { backgroundColor: "#6C0699", iconColor: "#FFF", isBackOrder: true }],
  [APPOINTMENT_NOTE_TYPES.MakeAnOffer, { backgroundColor: "#FFEB3B", icon: "dollar sign", iconColor: "#000000" }],
  [APPOINTMENT_NOTE_TYPES.WO, { backgroundColor: "#2185D0", icon: "file alt", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.Main, { backgroundColor: "#FF0202", icon: "sticky note", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.CallCustomer, { backgroundColor: "#21BA45", icon: "phone alt", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.Bill, { backgroundColor: "#46B046", icon: "file invoice dollar", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.Tyrescanner, { backgroundColor: "#FF8800", icon: "tile", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.TempDriver, { backgroundColor: "#5C5C5C", icon: "steering wheel", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.RecurringCar, { backgroundColor: "#C83628", icon: "exclamation triangle", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.Attachment, { backgroundColor: "#21A1D0", icon: "paperclip", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.ParkingLocation, { backgroundColor: "#21A1D0", icon: "square parking", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.NoDrive, { backgroundColor: "#FF0301", icon: "circle minus", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.HighVoltageWarning, { backgroundColor: "#FFB73B", icon: "bolt", iconColor: "#FFF" }],
  [APPOINTMENT_NOTE_TYPES.XentryAttachment, { backgroundColor: "", iconColor: "", isXentry: true }]
]);

export const NoteTypeIconLabel = ({ type, isCarNote = false }: NoteTypeIconLabelProps) => {
  if (isCarNote)
    return (
      <div className="AppointmentNoteTypeIconLabel" style={{ backgroundColor: "#EA2D62" }}>
        <Icon className="car mirrors carNoteIcon" />
      </div>
    );

  const noteTypeConfig = NoteTypeIconMapConfig.get(type);
  if (!noteTypeConfig) return null;

  const getNoteIcon = () => {
    if (noteTypeConfig.isBackOrder) return <span style={{ color: noteTypeConfig.iconColor }}>BO</span>;
    if (noteTypeConfig.isXentry) return <img className="noteTypeImage" src={xentryImg} alt="Xentry" />;

    return <Icon className={noteTypeConfig.icon} style={{ color: noteTypeConfig.iconColor }} />;
  };

  return (
    <div className="AppointmentNoteTypeIconLabel" style={{ backgroundColor: noteTypeConfig.backgroundColor }}>
      {getNoteIcon()}
    </div>
  );
};
